import { trigger, state, style } from '@angular/animations';
import { Component, Input, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { DatatableBaseComponent } from '@components/datatable-base.component';
import { DictionaryValuesService } from '@services/dictionaryValues.service';
import { UiService } from '@services/ui.service';

@Component({
  selector: 'app-dictionary-values-list',
  templateUrl: `./dictionary-values-list.component.html`,
  styleUrls: ['./dictionary-values-list.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0', display: 'none' })),
      state('expanded', style({ height: '*' }))
    ])
  ]
})

export class DictionaryValuesListComponent extends DatatableBaseComponent implements OnInit {
  dataSource: MatTableDataSource<any>;
  @Input() dictionary: string;
  @Input() data: any;

  @ViewChild('MatSort', { static: true }) public matSort: MatSort;
  @ViewChild('MatPaginator', { static: true }) matPaginator: MatPaginator;

  displayedColumns = ['name', 'dictionary', 'client', 'actions'];

  constructor(
    protected uiSrv: UiService,
    private dictionaryValuesSrv: DictionaryValuesService
  ) {
    super(uiSrv);
  }

  ngOnInit() {
    super.ngOnInit();

    if (this.dictionary === 'lots') this.displayedColumns = ['name', 'dictionary', 'client', 'site', 'actions'];

    this.initTable();
  }

  ngOnChanges(changes: SimpleChanges): void {
    //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    //Add '${implements OnChanges}' to the class.
    if (changes.data) {
      this.initTable();
      this.onEditFinished();
    }
  }

  applyFilterTransportType(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  private initTable(): void {
    this.dataSource = new MatTableDataSource(this.data);
    this.dataSource.sortingDataAccessor = (item, property) => {
      switch (property) {
        case 'dictionary': return item.dictionary.description;
        case 'client': return item.client.name;
        case 'site': return item.site.name;
        default: return item[property];
      }
    };
    this.dataSource.filterPredicate = (data, filter: string) => {
      const accumulator = (currentTerm, key) => {
        switch (key) {
          case 'client': return currentTerm + data.client.name;
          case 'site': return currentTerm + data?.site?.name;
          default: return currentTerm + data[key];
        }
      };
      const dataStr = Object.keys(data).reduce(accumulator, '').toLowerCase();
      // Transform the filter by converting it to lowercase and removing whitespace.
      const transformedFilter = filter.trim().toLowerCase();
      return dataStr.indexOf(transformedFilter) !== -1;
    };

    this.dataSource.sort = this.matSort;
    this.dataSource.paginator = this.matPaginator;
  }

  deleteDictionaryValue(idDictionaryValue: string) {
    let message = this.dictionary === 'transportTypes' ? 'Êtes-vous certain de vouloir supprimer ce type de transport ?' : 'Êtes-vous certain de vouloir supprimer ce niveau d\'urgence ?';
    const confirmation = confirm(message);

    if (confirmation) {
      if (this.dictionary === 'transportTypes') {
        this.dictionaryValuesSrv.deleteTypeTransport(idDictionaryValue).subscribe(() => {
          this.uiSrv.showSnackbar('repository.transportTypes.deleted', true);
        });
      } else if (this.dictionary === 'urgencyLevels') {
        this.dictionaryValuesSrv.deleteUrgencyLevel(idDictionaryValue).subscribe(() => {
          this.uiSrv.showSnackbar('repository.urgencyLevels.deleted', true);
        });
      } else if (this.dictionary === 'lots') {
        this.dictionaryValuesSrv.deleteLot(idDictionaryValue).subscribe(() => {
          this.uiSrv.showSnackbar('repository.lots.deleted', true);
        });
      }

    }
  }
}
